import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const ecApi = AiseaApiFactory.get("enterpriseCamera");
import { CAMERA_CATEGORY } from "@/config/const";
import _ from "lodash";

export default {
  async fetchCameras({ commit }) {
    let response = await ecApi.search();
    if (response.data.cameras.length !== 0) {
      let cameras = [];
      let vessels = [];
      response.data.cameras.forEach((camera) => {
        let vesselId;
        let category;
        // カメラの情報にカテゴリがわかるものがないので、vesselがあるものは「船舶」、ないものは「その他」としている
        if (camera.vessel) {
          vesselId = camera.vessel.id;
          category = CAMERA_CATEGORY.VESSEL; // 船舶
        } else {
          vesselId = 0;
          category = CAMERA_CATEGORY.OTHERS; // その他
        }
        let cameraInfo = {
          id: camera.id,
          movieType: camera.movie_type,
          name: camera.name,
          description: camera.description,
          vesselId: vesselId,
          hash: camera.hash,
          isShow: true,
          category: category,
          onvifUserName: camera.onvif_user_name,
          onvifPassword: camera.onvif_password,
          onvifProfileToken: camera.onvif_profile_token,
        };
        cameras.push(cameraInfo);
        if (camera.vessel) {
          vessels.push(camera.vessel);
        }
      });
      commit("SET_CAMERAS", cameras);
      let vesselsMap = new Map(vessels.map((o) => [o.id, o]));
      commit("SET_VESSELS_NAME", Array.from(vesselsMap.values()));
      let vesselIds = [];
      let keys = vesselsMap.keys();
      for (let key of keys) {
        vesselIds.push(key);
      }
      return vesselIds;
    } else {
      commit("SET_NO_CAMERAS", true);
    }
  },

  async filterCamera({ commit, state }, filterCondition) {
    const copyCameras = _.cloneDeep(state.cameras);
    let categoryCameraList;

    // カテゴリ「すべて」で絞り込み
    if (filterCondition.category === CAMERA_CATEGORY.ALL) {
      categoryCameraList = copyCameras.map((camera) => {
        camera.isShow = true;
        return camera;
      });
      // カテゴリ「船舶」で絞り込み
    } else if (filterCondition.category === CAMERA_CATEGORY.VESSEL) {
      categoryCameraList = copyCameras.map((camera) => {
        if (CAMERA_CATEGORY.VESSEL === camera.category) {
          camera.isShow = true;
          return camera;
        } else {
          camera.isShow = false;
          return camera;
        }
      });
      // カテゴリ「その他」で絞り込み
    } else {
      categoryCameraList = copyCameras.map((camera) => {
        if (CAMERA_CATEGORY.OTHERS === camera.category) {
          camera.isShow = true;
          return camera;
        } else {
          camera.isShow = false;
          return camera;
        }
      });
    }

    //カテゴリが「すべて」or「船舶」場合はさらに船舶IDで絞り込み
    if (
      filterCondition.category === CAMERA_CATEGORY.ALL ||
      filterCondition.category === CAMERA_CATEGORY.VESSEL
    ) {
      const filteredCameraList = categoryCameraList.map((camera) => {
        if (camera.category !== CAMERA_CATEGORY.VESSEL) {
          return camera;
        }
        const exists = filterCondition.vesselIds.includes(camera.vesselId);
        if (exists) {
          camera.isShow = true;
          return camera;
        } else {
          camera.isShow = false;
          return camera;
        }
      });
      commit("SET_CAMERAS", filteredCameraList);
    } else {
      //その他
      commit("SET_CAMERAS", categoryCameraList);
    }
  },

  async resetCameraListState({ commit }) {
    let defaultState = {
      noCameras: false,
      categories: null,
      vesselsName: null,
      cameras: [],
    };
    commit("RESET_STATE", defaultState);
  },

  async getCamera(_, cameraId) {
    const res = await AiseaApiFactory.get("enterpriseCamera").search();
    return res.status ? res.data.cameras.find((x) => x.id === cameraId) : null;
  },

  async hykeCamGetMedia(_, payload) {
    const res = await AiseaApiFactory.get("enterpriseCamera").hykeCamGetMedia(
      payload,
    );
    return res.data;
  },

  async updateCamerasSortOrder(_nouse, payload) {
    let response = await ecApi.updateSortOrder(payload);
    if (!response || !response.status) {
      throw response;
    }
  },
};
